import { type } from "../types/types";

export const set_width = (width) => (dispatch) => {
  dispatch({
    type: type.SET_WIDTH,
    width,
  });
};

export const set_loading = (isLoading) => (dispatch) => {
  dispatch({
    type: type.SET_LOADING,
    isLoading,
  });
};

export const set_direction = (language) => (dispatch) => {
  dispatch({
    type: type.SET_DIRECTION,
    direction: language.toLowerCase() === "english" ? "LTR" : "RTL",
  });
};
